import React, { useState } from "react";
//import Corona from "../../assets/covidbanner_v_copy.png";
import PmCreative from "../../assets/pm-creative.jpg";
import AwardAdvertise from "../front/AwardAdvertise";

export function CoronAdv({ isDesktopView }) {
  const [isBannerModalVisible, setIsBannerModalVisible] = useState(false);
  return (
    <React.Fragment>
      <div
        style={{
          paddingTop: `${isDesktopView ? "40px" : "10px"}`,
          backgroundColor: "#172e40",
          cursor: "pointer",
          display: "none"
        }}
        onClick={() => setIsBannerModalVisible(true)}
      >
        <img src={PmCreative} style={{ width: "100%" }} loading="lazy" />
      </div>
      {isBannerModalVisible ? (
        <AwardAdvertise
          show={isBannerModalVisible}
          closeModal={() => setIsBannerModalVisible(false)}
        />
      ) : null}
    </React.Fragment>
  );
}
